import React from 'react';
import PropTypes from 'prop-types';

import BEM from 'components/utils/BEM';
import './style.scss';

const Form = ({ children, className, ...restProps }) => (
  <form noValidate className={BEM('form').mix(className)} {...restProps}>
    {children}
  </form>
);

Form.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Form.defaultProps = {
  children: null,
  className: '',
};

export default Form;

export { default as FormError } from './components/FormError';
export { default as FormGroupField } from './components/FormGroupField';
export { default as FormGroupTextarea } from './components/FormGroupTextarea';
export { default as FormField } from './components/FormField';
export { default as FormGroupPassword } from './components/FormGroupPassword';
export {
  default as FormGroupPasswordFloatLabels,
} from './components/FormGroupPasswordFloatLabels';
export {
  default as FormGroupTextareaFloatLabels,
} from './components/FormGroupTextareaFloatLabels';
export { default as FormGroupCheckbox } from './components/FormGroupCheckbox';
export { default as FormGroupRadio } from './components/FormGroupRadio';
export { default as FormGroupSelect } from './components/FormGroupSelect';
export { default as FormGroupTags } from './components/FormGroupTags';
export { default as FormGroup } from './components/FormGroup';
export {
  default as FormGroupFieldFloatLabels,
} from './components/FormGroupFieldFloatLabels';
export { default as FormLabel } from './components/FormLabel';
export { default as FormSubmit } from './components/FormSubmit';
export { default as FormGroupFile } from './components/FormGroupFile';
